export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || "";
console.log(import.meta.env)
